import { css } from "@emotion/css"

import Spacer from "@p-ban/common/src/components/layout/Spacer"

import MyPageMainContent from "../../../components/mypage/MyPageMainContent"
import Divider from "../../../components/mypage/layout/Divider"
import useViaReferralLink from "../hooks/useViaReferralLink"
import Step from "./Step"

import title from "../images/title.png"
import titleWithCouponApplied from "../images/titleWithCouponApplied.png"

type Props = {
  children: React.ReactNode
  currentStep: "メール確認" | "登録選択" | "入力フォーム" | "登録完了"
  subTitle: string
}

const SignUpTemplate = ({ children, currentStep, subTitle }: Props) => {
  const { viaReferralLink } = useViaReferralLink()
  const src = viaReferralLink ? titleWithCouponApplied : title
  const alt = viaReferralLink ? "新規ユーザー登録　お友達紹介クーポン適用" : "新規ユーザー登録"

  const gap = 20

  return (
    <MyPageMainContent src={src} alt={alt}>
      <div className={styles.container}>
        <Step current={currentStep}>メール確認</Step>
        <Divider width={gap} />
        <Step current={currentStep}>登録選択</Step>
        <Divider width={gap} />
        <Step current={currentStep}>入力フォーム</Step>
        <Divider width={gap} />
        <Step current={currentStep}>登録完了</Step>
      </div>
      <Divider />
      <Spacer size={40} />
      <h3 className={styles.subTitle}>{subTitle}</h3>
      <Spacer size={40} />
      {children}
    </MyPageMainContent>
  )
}

export default SignUpTemplate

const styles = {
  container: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px 0;
  `,
  subTitle: css`
    font-size: 24px;
    font-weight: normal;
  `,
}
